import { IUpdateUsuarioUseCase } from "../../../presentation/useCases/update/update_usuario_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * UpdateUsuarioUseCase
 */

export class UpdateUsuarioUseCase implements IUpdateUsuarioUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(
    idUsuario: number,
    nome: string,
    login: string,
    senha: string | null,
    email: string,
    centroCustoRestrito: boolean,
    bloqueado: boolean,
    isConfigured?: boolean,

    idFuncionario?: number,
    gruposUsuario?: number[],
    restricoesCentroCusto?: number[],
  ): Promise<void> {
    await this.repository.updateUsuario(
      idUsuario,
      nome,
      login,
      senha,
      email,
      centroCustoRestrito,
      bloqueado,
      isConfigured ?? true,

      idFuncionario,
      gruposUsuario,
      restricoesCentroCusto,
    );
  }
}
